module.exports = __webpack_public_path__ + "img/wx_circular_green_200.79694c6e.svg";